// UGG AI Lab mock pack — the demo's scripted questions and their full typed-block
// responses (block kinds → pages/Lab/blocks/index.js). Same authoring law as
// mock/lab/starbucks.js and mock/lab/tiffany.js: readout first and VERDICT
// ONLY (no `body` paragraph — user call 2026-09-08), CMO cultural-capital
// vocabulary (never engine internals), NAMED concepts, digit-free modelView,
// provenance observed / projected / measured. Pure data, no imports
// (scripts/dump-lab-fixture.js evaluates the file).
//
// The brief (user, 2026-09-10): a third pack "like Starbucks and Tiffany",
// persona Alex (David until 2026-09-12, user call) again, three questions on the product types that matter for
// UGG — COLLABORATIONS, EXPERIENCES and CONTENT — analysed first against the
// live record and the brand's current state and plans, then scripted with the
// same charts the Tiffany labs use. The three labs: the collab scout ("Who
// should we collaborate with next?"), the experience lab ("Where should UGG
// season happen — and what should we do there?") and the content lab ("What
// content should carry UGG season?").
//
// Numbers + references are calibrated to the LIVE dev DB (2026-08-24 run,
// UGG joined the board 2026-09-09): UGG CIQ 51.0, rank #32 of 33, +3.7 on the
// window — the board's second-biggest climb (Saint Laurent +5.2) and the
// biggest in the bottom half; fifty-two items since April 21. Lanes: merch 88
// (the strongest, saturated), art direction 78, content 77 (saturated — on
// volume), brand codes 70, collab 68 (imputed at 15 until August, then four
// drops in three weeks), event 44, experience 29 (the weakest measured lane,
// down from 35 in June). Capital: fandom is the FOCUS (brand share 4% against
// the field's 7%), identity signal is over-invested (24% vs 18%), scarcity is
// a dial the brand never turns, opacity is near zero. Search volume climbed
// 19 → 53 across the served windows — the seasonal ramp had begun by August.
// Cited precedents are REAL measured items on the same run, at their
// effective pts.
//
// The collab scout's basis (analysis 2026-09-10): four collabs, all in
// August. The Willy Chavarria debut capsule is UGG's strongest play on the
// shelf (56.6 pts, presence 70, valence +67 — the ninth collab on the whole
// board) and the ONLY one with a crowd coded (fandom 0.3), and it was STACKED:
// the '90s-sitcom campaign (content, April 27, base 48 — the highest-graded
// piece on the shelf, received 0), the Paris Fashion Week runway debut
// (event, June 26, base 51.7 — the strongest event), then the capsule (August
// 11). Palace (partner tier 80, cult credibility 80) and Children of the
// Discordance had the credibility and no queue — received 25, cooled to 20 —
// and Babor (skincare) graded on unexpectedness alone. Every rationale reads
// the same: partner 60–80, high-low tension 60, unexpectedness 60; resale,
// limited availability, hype and new-audience pull 0–20. The field's collab
// bands (513 plays): median 18, ceiling 26, max 73.3. The most-RECEIVED shape
// is the fandom object — a crowd that already exists: Nike × One Piece 64.0
// (presence 75), McDonald's Hello Kitty × Godzilla 63.7, Starbucks × POP MART
// MOLLY 58.5 (presence 85), Duolingo × Genshin 55.5; the highest single
// collab is a cross-world OBJECT (Louis Vuitton × Singer Porsche 73.3,
// presence 90; Saint Laurent × Wilson 47.5, × Fieldbar 46.1); designer
// elevation ceilings near 50 (Dior × Thebe Magugu 49.5); sport and team is
// the floor (Lululemon × MLB 31.9 then 13.8, Nike × Palace England 22.8 then
// 11.8). The arena's bands are per-shape typical (median) and ceiling (upper
// quartile) of graded strength, hand-grouped by shape; its dots UGG's own
// bases. Observed, not measured: the Hidden.NY drop of February 2026 sold out
// fast with more than half its buyers 18–34 and new to the brand (the first
// collab-acquisition figure ever given on a Deckers call); Palace × UGG is an
// annual December drop (the hoodie resells at three times retail); sacai's
// thigh-high put a thousand-dollar UGG on the shelf and the Chavarria Guard
// Boot an eight-hundred-dollar one; the Tasman Albite shipped as two thousand
// numbered hand-whipstitched pairs; Asia converts at full price and led the
// latest quarter. The quadrant's partner candidates are modeled on that
// record.
//
// The experience lab's basis (analysis 2026-09-10, same run): four
// experiences and eight events. The STRONGEST experience is a sheepskin
// factory in New South Wales the brand does not own (Mortels — tours, the
// Sheep's Back Museum, the café; base 38.4, presence 55, destination pull
// 80); the best-RECEIVED is the Sunroom in London (34.0, presence 60), which graded "interchangeable
// with any sponsor"; two mall pop-ups read 19 and 9. The strongest event was
// the Chavarria runway (51.7); the ONE public crowd on the shelf was a
// hot-dog stand — the Gray's Papaya street party (28.3, presence 55). Two
// ambassador appearances (Seoul, Shanghai), Milan design week, Mother's Day
// and The Courtyard graded "no queue, no named tastemaker". The field's
// experiences that carry REPEAT and sit where a crowd already is: Uniqlo's
// MoMA Friday nights 37.4 (presence 85), Coca-Cola's soda fountain at The
// Battery 44.6 (80), Nike's Crenshaw Rec 30.0, Red Bull Cliff Diving Mostar
// 71.4 (90), Nike at Fanatics Fest 41.8; the own-rooms ceiling is a
// restaurant that stays open (Gaggan at Louis Vuitton 70.1). Observed, not
// measured: Feel House NYC (October 24–28, 2025, the fourth edition, curated
// by A$AP Ferg — Sarah Jessica Parker, Lil Yachty, Stefon Diggs on the list)
// is a house built for four days; the Barclays Center "Icon Arcade"
// (November 18 and December 18, 2025) was two nights on an arena plaza in a
// season with more than fifty NBA sightings in UGG — the right stage, the
// wrong duration; the College Ambassador program (nine art students, August
// to October 2026); the Paris Fashion Week pop-up in Le Marais (January
// 2026); the season is WEATHER — search index 70–95 in November and December,
// a trough March to July — and management's stated enemy is winter
// dependence. The matrix and the city map are modeled indexes on that record.
//
// The content lab's basis (analysis 2026-09-10, same run): thirteen pieces,
// twelve of them a face in a seasonal product campaign, median base 24;
// casting pull is the craft dimension graded highest most often (Wang Yibo
// 80, Sarah Jessica Parker and Stefon Diggs 60, Metro Boomin 60); derivative
// content graded 0 on eleven of thirteen (20 on two) and memeability 0 on all but one; fandom coded on none, six
// carry no strategy at all. Received: Channel Tres 65, Kevin Abstract's "In
// Dreams" for the Tasman Flex 60 — the only piece STILL CLIMBING four months
// after landing (35 → 50 → 60) and the only one coded subculture 60; the
// Chavarria sitcom is the highest graded (48) and was received at 0; the one
// time the camera was handed over (the art students) it went out as a trade
// release (23.7). The field's carrying content (effective pts on the run):
// Apple "Shot on iPhone" 88.4 (crowd-made, fandom 1.0), Bottega Veneta's RM
// covers 77.2 (the face posts it), Gucci × Ningning 68.0, Dior's hand-drawn
// "The Story of A Miss" 50.1 (presence 90), Gap "Denim on your own" 42.0
// (presence 85 — the mass-fashion peer's own-denim campaign),
// Duolingo "RIP Duo" 41.0, Hermès × Sarah Martinon 40.4. The arena reuses
// the seven content formats and field bands of the Tiffany content lab (same
// field, same run); the radar's "your content" and "field" series are
// measured strategy fit, its crowd series and the quadrant's crowd pull are
// modeled. Observed, not measured: "UGG season" opens on TikTok every October
// without the brand (the Tasman-versus-Ultra-Mini comparison genre, the dupe
// discourse at ninety-million-plus views); the Zora ballet flat went viral on
// PinkPantheress's feet in autumn 2025 BEFORE she was cast for "Born to Feel"
// (September 2026); the Albite's two thousand numbered pairs and the Fluff
// Theater's practical-effects, anti-AI stance are the bench story the brand
// already owns and has never filmed.

export const UGG_LAB = {
  brand: "ugg",
  name: "UGG",
  // the demo persona greeted on the Lab — every mock pack carries one
  person: "Alex",
  // THE WEEKLY ONE (2026-10-21, pages/Leaderboard/WeeklyOne): the week's
  // one priority, the collab scout under the entry's own words and type,
  // with a PREVIEW drawn from the answer's own blocks — the trend is the
  // Fluff Box's projected lift on the published score (+0.9 over two
  // windows, the impact block; the series the climb), the ring the Labubu
  // pairing's cozy fit (84 of 100 on the candidates quadrant), the bars
  // the three drops priced ("Three drops, priced": the lift each carries,
  // printed as it is, drawn on a one-point scale). The overline's count
  // is the pack's.
  weekly: {
    sources: 1206940,
    cards: [
      {
        entry: "next-collab",
        measured: "2026-10-09",
        preview: {
          trend: {
            value: "+0.9",
            label: "CIQ, the Fluff Box",
            series: [0, 2, 3, 6, 10, 18, 30, 44, 56, 64, 72, 80, 86, 90],
          },
          ring: { value: 84, label: "Cozy fit, Labubu" },
          bars: {
            title: "Three drops, priced",
            rows: [
              { label: "POP MART", value: 90, text: "+0.9" },
              { label: "PinkPantheress", value: 70, text: "+0.7" },
              { label: "Herman Miller", value: 50, text: "+0.5" },
            ],
          },
        },
      },
    ],
  },
  entries: [
    {
      id: "next-collab",
      itemType: "collab",
      type: "collab",
      question: "Who should we collaborate with next?",
      aliases: [
        "who should we collab with next",
        "which collaboration should we do next",
        "which collab should we do next",
        "which collab should we drop next",
        "who should ugg collaborate with next",
        "what should our next collab be",
        "which partner should we collaborate with",
        "who should we partner with next",
      ],
      askedOn: "2026-09-08",
      blocks: [
        {
          kind: "readout",
          provenance: "projected",
          verdict:
            "Right partners, wrong drops: Chavarria was coded for a crowd, Palace had no queue. Pick a fandom, not a label.",
        },
        {
          kind: "arena",
          title: "Seven collab shapes, field and yours",
          provenance: "measured",
          unit: "graded strength · pts",
          note: "Bands are the field's range for collabs of each shape — typical to ceiling of graded strength across every brand on the board; the ring is the field's strongest collab there, the dots are your four. Received = the best presence measured for that shape. Tap a shape for the read.",
          rows: [
            {
              id: "fandom",
              label: "Fandom object",
              sub: "a character, a toy, an anime",
              typical: 44,
              ceiling: 58,
              best: {
                brandName: "Nike",
                title: 'One Piece "Devil Fruits" collection tease',
                pts: 47.0,
              },
              received: 90,
              status: "recommended",
              note: "The field's most-received shape — a crowd that already exists, handed an object: One Piece for Nike, Hello Kitty and Godzilla for McDonald's, MOLLY for Starbucks, all read at 75 to 90. You have never made one, and fandom is the capital your record is thinnest in.",
            },
            {
              id: "object",
              label: "Cross-world object",
              sub: "a car, a racket, a cooler",
              typical: 38,
              ceiling: 47,
              best: {
                brandName: "Louis Vuitton",
                title: "Singer Porsche 911 Reimagined",
                pts: 49.4,
              },
              received: 90,
              own: [{ title: "Babor × UGG", pts: 32.1 }],
              note: "The highest single collab on the board is an object from another world — a Porsche, a tennis racket, a gin trunk. Your one object was a skincare unboxing; the shape wants a thing people post, not a thing they open.",
            },
            {
              id: "designer",
              label: "Designer elevation",
              sub: "a name, a runway",
              typical: 36,
              ceiling: 47,
              best: {
                brandName: "Dior",
                title: "Thebe Magugu capsule",
                pts: 39.6,
              },
              received: 70,
              own: [
                { title: "Willy Chavarria capsule", pts: 42.3 },
                { title: "Children of the Discordance", pts: 37.7 },
              ],
              note: "Your best shape and your best play — Chavarria sits at the top of the field's band here because it was three plays in one: the sitcom, the runway, the boots. Children of the Discordance had the scene respect and no drop, and read 25.",
            },
            {
              id: "artist",
              label: "Artist & musician",
              sub: "a face with an army",
              typical: 33,
              ceiling: 45,
              best: {
                brandName: "Dior",
                title: "Travis Scott's Cactus Jack shoes",
                pts: 41.0,
              },
              received: 75,
              note: "The face who IS a fandom, given the product — Travis Scott for Dior, BTS for Nike. Your faces sit in your campaigns, never on your shelf as partners; the one whose feet sold a shoe last autumn is in your new film, not on a box.",
            },
            {
              id: "streetwear",
              label: "Streetwear label",
              sub: "the skate brand, the drop",
              typical: 30,
              ceiling: 41,
              best: {
                brandName: "Nike",
                title: 'Supreme Air Force 1 Low "Camo"',
                pts: 38.1,
              },
              received: 75,
              own: [{ title: "Palace × UGG", pts: 43.0 }],
              note: "Your default — Palace every December for four years. Partner tier 80, cult credibility 80, and this summer's drop was received at 25: the label lends credibility, the queue lends the score, and the queue was never built.",
            },
            {
              id: "retail",
              label: "Retailer edit",
              sub: "a store, a curation",
              typical: 30,
              ceiling: 38,
              best: {
                brandName: "Sephora",
                title: "Olive Young K-Beauty Edit",
                pts: 39.6,
              },
              received: 60,
              note: "The biggest collab lift on the board this window was a retailer bringing a scene's shelf to its own — Olive Young into Sephora. Hidden did this for you in February and it sold out; the record never saw it because it landed before the window.",
            },
            {
              id: "sport",
              label: "Sport & team",
              sub: "a league, a jersey",
              typical: 22,
              ceiling: 31,
              best: {
                brandName: "Lululemon",
                title: "Frances Tiafoe Australian Open kit",
                pts: 38.0,
              },
              received: 70,
              note: "The floor of the board — a league licence reads as a licence: Lululemon's four-hundred-piece MLB line read 32 and 14 across its two listings. Your fifty-plus courtside sightings this season are worth more as a stage than as a jersey.",
            },
          ],
        },
        {
          kind: "quadrant",
          title: "Partner candidates",
          provenance: "observed",
          x: { label: "Crowd already there", low: "a scene", high: "an army" },
          y: { label: "Cozy fit", low: "a stretch", high: "born for it" },
          quadrants: {
            tr: "Drop it",
            tl: "Right shape, small room",
            br: "A crowd, not yours",
            bl: "Leave it",
          },
          note: "Crowd reads the size and heat of the partner's own following this year; cozy fit reads how naturally the pairing sits inside UGG's codes — fluff, comfort, the couch. Hollow dots are partners you already ran. Dot size is how much of the story the partner would carry. Tap a dot for the read.",
          points: [
            {
              id: "pop-mart",
              label: "POP MART · Labubu",
              short: "POP MART",
              era: "Fandom object",
              color: "#FF5A76",
              x: 92,
              y: 84,
              w: 65,
              status: "recommended",
              note: "The year's collectible crowd, and the toy is already furry. Starbucks read 85 with MOLLY; a sheepskin charm on a Tasman is the most UGG object anyone could make.",
            },
            {
              id: "pinkpantheress",
              label: "PinkPantheress · the Zora",
              short: "PinkPantheress",
              era: "Artist & musician",
              color: "#F472B6",
              x: 74,
              y: 80,
              w: 55,
              status: "recommended",
              note: "The Zora went viral on her feet before you cast her — the demand test is done. Her edition, numbered, on her channels first.",
            },
            {
              id: "herman-miller",
              label: "Herman Miller · the Eames lounge",
              short: "Herman Miller",
              era: "Cross-world object",
              color: "#FFB74D",
              x: 48,
              y: 88,
              w: 45,
              status: "recommended",
              note: "The chair everyone knows, in the material everyone knows you for — an object for design week that the feed posts for you, the way it posted a Porsche.",
            },
            {
              id: "pokemon",
              label: "Pokémon · Snorlax",
              era: "Fandom object",
              color: "#FF5A76",
              x: 96,
              y: 72,
              w: 60,
              note: "The biggest crowd on the map and the cosiest character in it — but Nike and Uniqlo are already on that shelf this summer; you would be the third.",
            },
            {
              id: "sanrio",
              label: "Sanrio · Hello Kitty",
              era: "Fandom object",
              color: "#FF5A76",
              x: 88,
              y: 60,
              w: 50,
              note: "Received at 70 and 75 for McDonald's twice this summer — a Happy Meal crowd, and a shape the fast-food shelf now owns.",
            },
            {
              id: "nba-team",
              label: "An NBA team · a jersey",
              era: "Sport & team",
              color: "#94A3B8",
              x: 82,
              y: 30,
              w: 40,
              note: "Fifty sightings courtside this season say the league is your stage, not your partner — a licence reads as a licence.",
            },
            {
              id: "palace",
              label: "Palace · the fifth December",
              era: "Streetwear label",
              color: "#B388FF",
              x: 56,
              y: 66,
              w: 50,
              status: "recent",
              note: "Four Decembers in, credibility on tap — and this summer's drop read 25. Keep the slot, change the mechanic: numbered, one door, one day.",
            },
            {
              id: "hidden",
              label: "Hidden.NY · the February queue",
              era: "Retailer edit",
              color: "#2DD4BF",
              x: 46,
              y: 62,
              w: 45,
              status: "recent",
              note: "Sold out fast, more than half the buyers new to you and under thirty-five — the proof that the queue, not the label, is the score.",
            },
            {
              id: "chavarria",
              label: "Willy Chavarria · the stack",
              era: "Designer elevation",
              color: "#60A5FA",
              x: 40,
              y: 74,
              w: 55,
              status: "recent",
              note: "Runway, sitcom, boots — your strongest play and the only one with a crowd coded. Out today at eight hundred dollars; let it breathe.",
            },
            {
              id: "sacai",
              label: "sacai · the thigh-high",
              era: "Designer elevation",
              color: "#60A5FA",
              x: 34,
              y: 64,
              w: 40,
              status: "recent",
              note: "A thousand-dollar UGG that stole the fashion-week show — trade applause, a small room.",
            },
            {
              id: "cotd",
              label: "Children of the Discordance",
              era: "Designer elevation",
              color: "#60A5FA",
              x: 22,
              y: 58,
              w: 30,
              status: "recent",
              note: "Scene respect, calf hair, embroidery — received at 25. The room was too small to hear it.",
            },
            {
              id: "babor",
              label: "Babor · skincare",
              era: "Cross-world object",
              color: "#FFB74D",
              x: 18,
              y: 34,
              w: 25,
              status: "recent",
              note: "Unexpected, and that was the whole grade — one unboxing post, no object anyone wanted to hold.",
            },
            {
              id: "designer-luxury",
              label: "Another luxury house",
              era: "Designer elevation",
              color: "#60A5FA",
              x: 28,
              y: 44,
              w: 35,
              note: "A fourth name in a year reads as a habit. The ladder from a hundred and thirty dollars to a thousand is built; the next step is a crowd, not a price.",
            },
          ],
        },
        {
          kind: "playsTimeline",
          title: "Your collabs, and three drops priced",
          provenance: "projected",
          today: "2026-09-10",
          note: "Left of NOW: every collab on your measured shelf by strength today, with the two plays that made the Chavarria capsule a stack — its campaign and its runway — in their own colours. Right of NOW: the three drops on their own projected-CIQ scale — height is impact. Tap a dot for the read.",
          points: [
            {
              d: "2026-04-27",
              v: 18.1,
              label: "Willy Chavarria × UGG — the sitcom campaign",
              itemType: "content",
            },
            {
              d: "2026-06-26",
              v: 21.6,
              label: "Willy Chavarria × UGG — the Paris runway debut",
              itemType: "event",
            },
            {
              d: "2026-08-03",
              v: 20.4,
              label: "Palace × UGG",
              itemType: "collab",
            },
            {
              d: "2026-08-11",
              v: 56.6,
              label: "Willy Chavarria × UGG — the debut capsule",
              itemType: "collab",
            },
            {
              d: "2026-08-12",
              v: 21.7,
              label: "Children of the Discordance × UGG",
              itemType: "collab",
            },
            {
              d: "2026-08-20",
              v: 37.1,
              label: "Babor × UGG",
              itemType: "collab",
            },
            {
              d: "2026-11-12",
              v: 62,
              label: "UGG × POP MART — the Fluff Box",
              itemType: "collab",
              projected: true,
              effect: 0.9,
              detail: "projected +0.9 CIQ",
            },
            {
              d: "2027-02-05",
              v: 54,
              label: "PinkPantheress × UGG — the Zora, her edition",
              itemType: "collab",
              projected: true,
              effect: 0.7,
              detail: "projected +0.7 CIQ",
            },
            {
              d: "2027-04-20",
              v: 46,
              label: "UGG × Herman Miller — the Eames lounge in sheepskin",
              itemType: "collab",
              projected: true,
              effect: 0.5,
              detail: "projected +0.5 CIQ",
            },
          ],
        },
        {
          kind: "plays",
          title: "Three drops, priced",
          provenance: "projected",
          plays: [
            {
              name: "UGG × POP MART — the Fluff Box: Tasman and Ultra Mini in blind-box colourways, a sheepskin Labubu on the heel",
              itemType: "collab",
              window:
                "November · Shanghai and Seoul first, numbered, one week before the rest of the world — the holiday window",
              strategies: [
                { code: "fandom", fit: 0.9 },
                { code: "scarcity", fit: 0.8 },
                { code: "aesthetic_innovation", fit: 0.5 },
              ],
              why: "The field's most-received collab shape is a crowd that already exists, handed an object — and fandom is the capital your record is thinnest in. POP MART's crowd is the collectible crowd of the year, the toy is already furry, and Asia is where your full-price conversion lives. A blind box turns one drop into a chase: the colourway you did not get is the reason to queue again. Starbucks read 85 with MOLLY on a cup; this is the same crowd on the object you make.",
              effect: {
                label: "CIQ",
                delta: 0.9,
                series: [0, 0.4, 0.7, 0.85, 0.9],
              },
              precedents: 11,
              reception: "the fandom object is received at 90",
              similar: [
                {
                  brand: "nike",
                  brandName: "Nike",
                  title: 'Nike x One Piece "Devil Fruits" Collection Tease',
                  pts: 64.0,
                },
                {
                  brand: "mcdonalds",
                  brandName: "McDonald's",
                  title: "Hello Kitty & Friends x Godzilla Happy Meal Collab",
                  pts: 63.7,
                },
                {
                  brand: "starbucks",
                  brandName: "Starbucks",
                  title: "Starbucks and POP MART Celebrate 20 Years of MOLLY",
                  pts: 58.5,
                },
              ],
            },
            {
              name: "PinkPantheress × UGG — the Zora, her edition: two thousand numbered pairs, her channels first",
              itemType: "collab",
              window:
                "February · spring, the Albite mechanic — numbered, hand-finished, her post before your press",
              strategies: [
                { code: "fandom", fit: 0.8 },
                { code: "scarcity", fit: 0.7 },
                { code: "identity_signal", fit: 0.5 },
              ],
              why: "The Zora went viral on her feet last autumn before you cast her for the fall film — the demand test ran itself. The field's artist collabs carry when the face is a fandom and the product is theirs: Travis Scott's shoe for Dior read 56, BTS's merch for Nike 43. Give her the flat as an edition, in the Albite's numbers, and let her channel go first; your film about her is your advertisement, her box is her fans'.",
              effect: {
                label: "CIQ",
                delta: 0.7,
                series: [0, 0.3, 0.55, 0.65, 0.7],
              },
              precedents: 8,
              reception: "the face's own drop is received at 75",
              similar: [
                {
                  brand: "dior",
                  brandName: "Dior",
                  title: "Travis Scott's Cactus Jack x Dior Shoes",
                  pts: 56.5,
                },
                {
                  brand: "nike",
                  brandName: "Nike",
                  title:
                    "Nike x BTS WORLD TOUR “ARIRANG” Merch and Nike By You Experience",
                  pts: 42.8,
                },
                {
                  brand: "nike",
                  brandName: "Nike",
                  title:
                    "Steven Victor x Nike Air Force 1 '01 Collection with Accompanying EPs",
                  pts: 37.0,
                },
              ],
            },
            {
              name: "UGG × Herman Miller — the Eames lounge in sheepskin, an edition for design week",
              itemType: "collab",
              window:
                "April · Milan design week, where you already show — fifty chairs, then the ottoman for everyone",
              strategies: [
                { code: "aesthetic_innovation", fit: 0.8 },
                { code: "scarcity", fit: 0.7 },
                { code: "opacity", fit: 0.4 },
              ],
              why: "The highest single collab on the board is an object from another world that the feed posts for the brand — a Porsche for Louis Vuitton, a racket for Saint Laurent. Your material is the most recognisable comfort code in the world and it has only ever been a shoe. The chair everyone knows, in the fleece everyone knows, is the object that says UGG is a house, not a boot — and it carries the one capital you never spend: the thing nobody else could make.",
              effect: {
                label: "CIQ",
                delta: 0.5,
                series: [0, 0.15, 0.3, 0.45, 0.5],
              },
              precedents: 7,
              similar: [
                {
                  brand: "louis-vuitton",
                  brandName: "Louis Vuitton",
                  title:
                    "Louis Vuitton x Singer Porsche 911 Reimagined Collection",
                  pts: 73.3,
                },
                {
                  brand: "saint-laurent",
                  brandName: "Saint Laurent",
                  title:
                    "Saint Laurent Rive Droite x Wilson Tennis Racket and Balls",
                  pts: 47.5,
                },
                {
                  brand: "bottega-veneta",
                  brandName: "Bottega Veneta",
                  title:
                    "Bottega Veneta x Flos Reinterpretation of Gino Sarfatti's Model 600 Table Lamp",
                  pts: 36.9,
                },
              ],
            },
          ],
          footnote:
            "Projected effects assume the drop is BUILT — numbered, one door first, a date said out loud — priced on your measured collab record; the ceiling is the field's best collab of the same shape.",
        },
        {
          kind: "impact",
          title: "What the Fluff Box does to your CIQ",
          provenance: "projected",
          delta: 0.9,
          body: "The POP MART box, dropped into the holiday window in Shanghai and Seoul first, carries a projected lift on your published score over the following two windows — most of it in the first, as the collectible crowd queues and posts, with the rest arriving as the colourways nobody got show up on resale.",
        },
        {
          kind: "modelView",
          body: "Pick a fandom, then build the queue. Your collab year chose partners the way a fashion house does — a skate label, a Paris name, a Japanese atelier — and shipped them the way a department store does: a press day, a page, no number, no door, no date.\n\nThe one that carried was the one you stacked and the one with a crowd coded, and the drop the record never saw — the February queue — is the one that brought you new buyers under thirty-five. The field says the shapes that carry are a crowd that already exists and an object people post, and that a licence reads as a licence and a fourth label reads as a habit. So give the collectible crowd a furry box, give the singer whose feet sold your flat her own numbered edition, and put your fleece on the chair everyone knows. Keep Palace's December, but turn the dial you have never touched: one door, one day, a number on the box.",
        },
      ],
    },
    {
      id: "where-ugg-season",
      itemType: "experience",
      type: "experience",
      // no brand name on the home page (user call 2026-09-10 — the ideas
      // read as Alex's own questions, not as a brand brief); the earlier
      // wording stays below as an alias
      question: "Where are our fans going to show up?",
      aliases: [
        "where should ugg season happen and what should we do there",
        "where should ugg season happen",
        "where are our fans going to show up this season",
        "where will our fans show up",
        "where should we show up this season",
        "where should we show up this winter",
        "where in culture should we show up next",
        "which experience should we do next",
        "should we do feel house again",
        "where should feel house go next",
        "which experience would have the biggest impact",
        "should we do it in our store or somewhere else",
      ],
      askedOn: "2026-09-07",
      blocks: [
        {
          kind: "readout",
          provenance: "projected",
          verdict:
            "Stop building a house for four days. Put the season where the crowd lines up and keep it open till the snow melts.",
        },
        {
          kind: "arena",
          title: "Seven stages, field and yours",
          provenance: "measured",
          unit: "graded strength · pts",
          note: "Bands are the field's range for experiences and events on each stage — typical to ceiling of graded strength across every brand on the board; the ring is the field's strongest play there, the dots are yours. Received = the best presence measured on that stage. Tap a stage for the read.",
          rows: [
            {
              id: "arena",
              label: "The arena",
              sub: "the court, the plaza, the game",
              typical: 30,
              ceiling: 40,
              best: {
                brandName: "Red Bull",
                title: "Cliff Diving World Series — Mostar",
                pts: 46.0,
              },
              received: 90,
              status: "recommended",
              note: "The field's best-received stage — public crowds the brand did not gather, read at 80 and 90. More than fifty courtside sightings in your boots this season, and your plaza at Barclays was open for two nights of it.",
            },
            {
              id: "cold",
              label: "The cold",
              sub: "the rink, the slope, the market",
              typical: 27,
              ceiling: 34,
              best: {
                brandName: "Coca-Cola",
                title: "Jacob's Soda Fountain at The Battery",
                pts: 39.6,
              },
              received: 85,
              note: "The stage the weather builds for you every November and nobody on the board has claimed — a public rink, a holiday market, an après-ski deck. The field's public places keep their level because they stay open; yours have never opened here.",
            },
            {
              id: "campus",
              label: "The campus",
              sub: "the quad, the library, finals",
              typical: 24,
              ceiling: 31,
              best: {
                brandName: "Dior",
                title: "Pre-Fall show at Trinity College Dublin",
                pts: 40.5,
              },
              received: 65,
              note: "Your back-to-school crowd and your nine student ambassadors — a stage you play as a campaign, never as a place. A room that stays open through finals is the format the field rewards on repetition.",
            },
            {
              id: "street",
              label: "The street",
              sub: "the hot-dog stand, the block",
              typical: 27,
              ceiling: 32,
              best: {
                brandName: "Coca-Cola",
                title: "The Battery Atlanta pop-up",
                pts: 39.6,
              },
              received: 85,
              own: [{ title: "Gray's Papaya street party", pts: 28.3 }],
              note: "Your one public crowd of the year — two days with a city-cult partner, received at 55 — and it graded interchangeable because it ended. The field's street plays hold because they come back.",
            },
            {
              id: "fashion",
              label: "Fashion week",
              sub: "the runway, the Marais pop-up",
              typical: 41,
              ceiling: 52,
              best: {
                brandName: "Chanel",
                title: "Fall/Winter 2026/27 Haute Couture show",
                pts: 63.3,
              },
              received: 85,
              own: [{ title: "Chavarria runway debut, Paris", pts: 51.7 }],
              note: "The field's strongest stage and your strongest event — but in Paris you are a guest on a designer's calendar; the runway is his format and the crowd is his front row.",
            },
            {
              id: "heritage",
              label: "Design & heritage",
              sub: "the factory, the archive, the fair",
              typical: 28,
              ceiling: 34,
              best: {
                brandName: "Louis Vuitton",
                title: "Visionary Journeys, LV The Place Bangkok",
                pts: 53.3,
              },
              received: 80,
              own: [
                { title: "Mortels sheepskin factory", pts: 38.4 },
                { title: "Visionaries, Milan design week", pts: 20.6 },
              ],
              note: "Your strongest place is a sheepskin factory in New South Wales that belongs to someone else — destination pull 80, because it is a place people drive to. Your own heritage stage was a booth at a design fair.",
            },
            {
              id: "rooms",
              label: "Your own rooms",
              sub: "the pop-up, the house, the mall",
              typical: 25,
              ceiling: 31,
              best: {
                brandName: "Louis Vuitton",
                title: "Gaggan at Louis Vuitton, Bangkok",
                pts: 68.6,
              },
              received: 85,
              own: [
                { title: "Sunroom, London", pts: 34.0 },
                { title: "Goldenstar pop-up", pts: 18.9 },
                { title: "Mother's Day in store", pts: 14.5 },
                { title: "Winston Hills pop-up", pts: 9.3 },
              ],
              note: "Your default — a pop-up, a workshop, a house built for four days and a guest list. Every rationale reads interchangeable; the field's ceiling here is a restaurant that stays open.",
            },
          ],
        },
        {
          kind: "matrix",
          title: "Duration × stage, priced as carry",
          provenance: "projected",
          cols: ["Your pop-up", "The city", "Someone else's stage"],
          note: "Cell brightness is modeled carry per play — what an experience of that shape is worth on your shelf, priced on the field's record and yours. Tap a cell for the read.",
          rows: [
            {
              label: "Four days · a house you build",
              cells: [
                {
                  v: 46,
                  note: "Feel House, the Sunroom, the Fluff Theater — beautifully built, read by the list that came, gone before the season starts.",
                },
                {
                  v: 52,
                  note: "The Gray's Papaya weekend, the Marais pop-up — a public crowd for two days grades as a stunt, because it ends.",
                },
                {
                  v: 58,
                  note: "Two nights at Barclays: the right stage, the wrong duration — the crowd was there for the other eighty games.",
                },
              ],
            },
            {
              label: "A season · a place that stays",
              cells: [
                {
                  v: 55,
                  note: "A house that stays open November to February becomes a place the city knows — the field's own rooms that carry are the ones with a lunch service.",
                },
                {
                  v: 74,
                  note: "A public rink, a campus room through finals — the field's street and city plays hold their level because they repeat: MoMA's Fridays, the soda fountain.",
                },
                {
                  v: 88,
                  note: "The field's ceiling — a crowd you did not have to gather, on a stage you did not have to build, every week of the season: Mostar, Fanatics Fest, an arena plaza for eighty nights.",
                },
              ],
            },
          ],
        },
        {
          kind: "geoCompare",
          title: "Host or guest — the pull of each city",
          provenance: "projected",
          metric: "Home-stage pull",
          focus: "new-york",
          note: "Modeled pull of a public, season-long experience in each city — whether the house is the host there or a guest on someone else's calendar. New York is the ringed focus; tap a city to read it against New York.",
          markets: [
            {
              id: "new-york",
              label: "New York",
              x: 30.3,
              y: 11.5,
              value: 92,
              note: "The host's city — Feel House, the Barclays plaza, the Gray's Papaya block, the SoHo and Fifth Avenue doors where Jeremy Scott dropped first. Every stage you need is already yours here.",
            },
            {
              id: "los-angeles",
              label: "Los Angeles",
              x: 17.7,
              y: 13.9,
              value: 76,
              note: "The home coast — the Fluff Theater in Venice, Feel House with Post Malone the year before, the founder's beach. The rink is the one thing it lacks.",
            },
            {
              id: "shanghai",
              label: "Shanghai",
              x: 86.1,
              y: 15.0,
              value: 71,
              note: "Full-price adoption of every new category and a Palace pop-up in December — the market that converts; a season-long room here is a flagship's work.",
            },
            {
              id: "seoul",
              label: "Seoul",
              x: 87.7,
              y: 12.6,
              value: 66,
              note: "An ambassador appearance and a spring activation — the fandom's capital, played so far through faces.",
            },
            {
              id: "london",
              label: "London",
              x: 51.4,
              y: 7.5,
              value: 60,
              note: "The Sunroom's city and Palace's — a creative crowd that came to the Boiler House and was never asked back.",
            },
            {
              id: "chengdu",
              label: "Chengdu",
              x: 80.4,
              y: 15.2,
              value: 55,
              note: "One of the spring's six activation cities and the region growing fastest — a stage with no shape yet.",
            },
            {
              id: "sydney",
              label: "Sydney",
              x: 92.0,
              y: 42.0,
              value: 50,
              note: "Your strongest place is an hour north of here and belongs to Mortels — the heritage stage you could host and don't.",
            },
            {
              id: "atlanta",
              label: "Atlanta",
              x: 26.1,
              y: 13.6,
              value: 44,
              note: "A store reopening with a photo booth this spring — the only door in the city, and the field's soda fountain a mile away shows what a place that stays reads like.",
            },
            {
              id: "milan",
              label: "Milan",
              x: 52.6,
              y: 9.5,
              value: 38,
              note: "Design week — a booth in April, a guest at the fair. The chair belongs here; the season does not.",
            },
            {
              id: "paris",
              label: "Paris",
              x: 52.1,
              y: 8.5,
              value: 34,
              note: "The guest's city — the runway is Chavarria's, the calendar is fashion week's, the Marais pop-up closed with it. Prices a third of New York.",
            },
          ],
        },
        {
          kind: "plays",
          title: "Three experiences, priced",
          provenance: "projected",
          plays: [
            {
              name: "Barclays, all season — the Icon Arcade as UGG's home court, every home game November to February",
              itemType: "experience",
              window:
                "November · opening night at the Center, then the plaza open for every home game through the All-Star break, livestreamed",
              strategies: [
                { code: "fandom", fit: 0.85 },
                { code: "identity_signal", fit: 0.6 },
                { code: "scarcity", fit: 0.3 },
              ],
              why: "More than fifty courtside sightings in your boots last season, and your plaza in Brooklyn was open for two nights of it. The field's experiences that carry are public crowds the brand did not gather, received at 80 and 90 — Red Bull at Mostar, Nike at Fanatics Fest — and an arena hands you that crowd forty times a winter. Keep the arcade, keep the stream, and stay: the plaza the city walks across on the way to the game is the most UGG-season place in New York.",
              effect: {
                label: "CIQ",
                delta: 0.8,
                series: [0, 0.35, 0.6, 0.75, 0.8],
              },
              precedents: 9,
              reception: "public sport plays are received at 80 and 90",
              similar: [
                {
                  brand: "red-bull",
                  brandName: "Red Bull",
                  title: "Red Bull Cliff Diving World Series 2026 - Mostar",
                  pts: 71.4,
                },
                {
                  brand: "nike",
                  brandName: "Nike",
                  title: "Nike at Fanatics Fest 2026",
                  pts: 41.8,
                },
                {
                  brand: "tesla",
                  brandName: "Tesla",
                  title: "Tesla Cybercab Public Demonstrations in Austin",
                  pts: 41.8,
                },
              ],
            },
            {
              name: "Feel Rink — Feel House becomes a public ice rink, open November to February, skates on the house",
              itemType: "experience",
              window:
                "November · a park rink in New York, then one in each host city — free skating, a warming hut, the boots on the bench",
              strategies: [
                { code: "identity_signal", fit: 0.75 },
                { code: "aesthetic_innovation", fit: 0.6 },
                { code: "fandom", fit: 0.4 },
              ],
              why: "Your season is weather — search climbs from the first cold week to the last — and nobody on the board has claimed the one public place the weather builds: the rink. Feel House was your best idea and it lasted four days for a list; a rink is the same house with the doors open, and the field's public places keep their level because they stay: Uniqlo's Fridays at MoMA, Coca-Cola's fountain that is still there. Free skating, a warming hut, cocoa — and the boots on the bench where everyone changes shoes.",
              effect: {
                label: "CIQ",
                delta: 0.7,
                series: [0, 0.3, 0.5, 0.65, 0.7],
              },
              precedents: 8,
              reception: "the public place reads at 85 when it stays",
              similar: [
                {
                  brand: "coca-cola",
                  brandName: "Coca-Cola",
                  title:
                    "Coca-Cola Pop-up Experience at The Battery Atlanta: Jacob's Soda Fountain",
                  pts: 44.6,
                },
                {
                  brand: "uniqlo",
                  brandName: "Uniqlo",
                  title: "NYC MoMA Friday Night Uniqlo Free Entry Program",
                  pts: 37.4,
                },
                {
                  brand: "jacquemus",
                  brandName: "Jacquemus",
                  title: "Jacquemus Beach Club Takeover at Monte-Carlo Beach",
                  pts: 36.5,
                },
              ],
            },
            {
              name: "The Warm Room — a study room on the ambassadors' campuses, open through finals",
              itemType: "experience",
              window:
                "October to December · nine art schools, the students' own rooms — late hours, free coffee, a sheepskin on every chair",
              strategies: [
                { code: "identity_signal", fit: 0.7 },
                { code: "fandom", fit: 0.5 },
                { code: "aesthetic_innovation", fit: 0.4 },
              ],
              why: "You already pay nine art students to make your autumn content, and the campus is where the Tasman is a uniform — and you play it as a back-to-school campaign, never as a place. Nike's rec center in Crenshaw and Dior's show in a Dublin college say the field reads a campus as a stage when the brand stays on it. A study room that opens in October and closes after finals, on the ambassadors' own campuses, gives their content a room and the room a reason to come back every night.",
              effect: {
                label: "CIQ",
                delta: 0.5,
                series: [0, 0.15, 0.3, 0.45, 0.5],
              },
              precedents: 6,
              reception: "a room that repeats reads at 65 to 85",
              similar: [
                {
                  brand: "dior",
                  brandName: "Dior",
                  title:
                    "Dior Announces Pre-Fall 2027 Show at Trinity College Dublin",
                  pts: 40.7,
                },
                {
                  brand: "nike",
                  brandName: "Nike",
                  title: "The Crenshaw Rec by Foot Locker",
                  pts: 30.0,
                },
                {
                  brand: "starbucks",
                  brandName: "Starbucks",
                  title: "Starbucks Hong Kong Palace Museum Concept Store",
                  pts: 29.8,
                },
              ],
            },
          ],
          footnote:
            "Projected effects assume the place STAYS — a season, not a weekend — priced on your measured experience record; the ceiling is the field's best play of the same shape.",
        },
        {
          kind: "impact",
          title: "What a season at Barclays carries",
          provenance: "projected",
          delta: 0.8,
          body: "The plaza open for every home game, from opening night through the All-Star break, carries a projected lift on your published score over the following two windows — most of it in the first, as the crowd and the stream land, with the rest arriving while the arcade keeps its queue into the new year.",
        },
        {
          kind: "modelView",
          body: "Keep the doors open. Your record says your experiences are rooms you build and close — a house for four days, a pop-up for a weekend, a workshop for an afternoon — and every one of them graded interchangeable, because a place that ends is a stunt whatever is inside it.\n\nYour strongest place belongs to a sheepskin factory in Australia, and your one public crowd came for hot dogs; the field says the experiences that carry are crowds the brand did not gather on stages it did not build, and that they keep their level because they come back. The mistake would be a bigger house or a fifth Paris pop-up. Your season is the weather, and the weather builds the stages for you: the arena on game night, the rink in the park, the library in finals week. Take the plaza for the whole schedule, open the rink and leave it open, and give the students a room. Where to show up is settled by who is already standing in the cold; what to do there is settled by whether you are still there next week.",
        },
      ],
    },
    {
      id: "season-content",
      itemType: "content",
      type: "content",
      // no brand name on the home page (user call 2026-09-10); the earlier
      // wording stays below as an alias
      question: "What content will perform best?",
      aliases: [
        "what content should carry ugg season",
        "what content will perform best this season",
        "what content performs best",
        "who should make our content this season",
        "what content should we make this season",
        "whats the highest engagement content",
        "which content performs best",
        "what should we post this season",
        "which content should we make for gen z",
        "what content works for ugg",
      ],
      askedOn: "2026-09-06",
      blocks: [
        {
          kind: "readout",
          provenance: "projected",
          verdict:
            "A face in a product shot, thirteen times over. Less casting, more crowd: the Tasman argument, PinkPantheress first, the bench.",
        },
        {
          kind: "arena",
          title: "Seven content formats, field and yours",
          provenance: "measured",
          unit: "graded strength · pts",
          note: "Bands are the field's range for content of each format — typical to ceiling of graded strength across every brand on the board; the ring is the field's strongest piece there, the dots are your thirteen. Received = the best presence measured for that format. Tap a format for the read.",
          rows: [
            {
              id: "crowd",
              label: "Crowd's content",
              sub: "creators, the argument",
              typical: 40,
              ceiling: 45,
              best: {
                brandName: "Apple",
                title: "Shot on iPhone",
                pts: 73.7,
              },
              received: 80,
              own: [{ title: "Back-to-school, the art students", pts: 23.7 }],
              status: "recommended",
              note: "The strongest content on the board is made by the crowd, and the mass-fashion peer's own-denim campaign read 85. UGG season opens on TikTok every October — Tasman versus Mini, the styling duels, the dupe fights — and the one time you handed over the camera, it went out as a trade release.",
            },
            {
              id: "camera",
              label: "Fandom's own camera",
              sub: "the face posts it",
              typical: 36,
              ceiling: 45,
              best: {
                brandName: "Bottega Veneta",
                title: "RM (BTS) ambassadorship covers",
                pts: 51.5,
              },
              received: 80,
              own: [{ title: "Wang Yibo, global ambassador", pts: 21.7 }],
              note: "A face the crowd already follows, posting the piece itself — received at 80 and read as the face's, not the house's. Your global ambassador announcement was received at 45 for one week and then nothing: an announcement is not a piece, and the shoe that went viral on a singer's feet last autumn was never hers to post.",
            },
            {
              id: "bench",
              label: "The bench",
              sub: "the whipstitch, the fleece",
              typical: 31,
              ceiling: 38,
              best: {
                brandName: "Louis Vuitton",
                title: "Reinvents the Trunk — the monogram at 130",
                pts: 40.3,
              },
              received: 65,
              note: "The format your house is built for and never films: two thousand hand-whipstitched Albites, the sheepskin, a factory people drive to — and a public stand against machine images. None of it is on your shelf.",
            },
            {
              id: "made",
              label: "Made thing",
              sub: "animated, practical effects",
              typical: 33,
              ceiling: 38,
              best: {
                brandName: "Saint Laurent",
                title: "Love Letters, Love Matters — the Qixi film series",
                pts: 41.4,
              },
              received: 90,
              note: "The best-received format of the summer — Dior's hand-drawn film read at 90. Your Fluff Theater built a miniature Los Angeles by hand in March and took a stand against AI images; the record never saw a frame of it.",
            },
            {
              id: "face",
              label: "Face film",
              sub: "a musician, a model, a season",
              typical: 31,
              ceiling: 37,
              best: {
                brandName: "Dior",
                title: "Miss Dior campaign film — Natalie Portman",
                pts: 38.1,
              },
              received: 85,
              own: [
                { title: "Chavarria × UGG, the sitcom", pts: 48.0 },
                { title: "Back-to-school with MUNA", pts: 33.8 },
                { title: "Channel Tres", pts: 33.0 },
                { title: "Kevin Abstract, In Dreams", pts: 31.2 },
                { title: "Elsa Hosk & Rina Sawayama", pts: 28.7 },
                { title: "Dusty Orchid — ADÉLA, Molly, Paloma", pts: 25.8 },
                { title: "SJP & Stefon Diggs", pts: 19.7 },
                { title: "Metro Boomin, filming", pts: 18.8 },
                { title: "Julez J. Smith Jr.", pts: 18.3 },
                { title: "Olandria", pts: 15.2 },
              ],
              note: "Your default — ten pieces this year, graded on who is in them and received at 0 to 65. The sitcom is your best-made piece and nobody shared it; the one still climbing is the one with a scene in it, not a star.",
            },
            {
              id: "tiein",
              label: "Tie-in",
              sub: "a partner's story",
              typical: 30,
              ceiling: 37,
              best: {
                brandName: "Starbucks",
                title: "Pumpkin Spice Latte × Martha Stewart",
                pts: 39.2,
              },
              received: 70,
              own: [{ title: "'Ain't In LA' music video", pts: 7.5 }],
              note: "A paid placement in someone else's video — your weakest piece of the year, graded as background.",
            },
            {
              id: "still",
              label: "Still & editorial",
              sub: "the campaign image",
              typical: 28,
              ceiling: 34,
              best: {
                brandName: "Saint Laurent",
                title: "Fall/Winter 2026 campaign",
                pts: 46.3,
              },
              received: 80,
              note: "The field's stills carry when a fandom face is in the frame — Saint Laurent's read 80. Yours arrive as films and product pages; the still is the one format you skip.",
            },
          ],
        },
        {
          kind: "radar",
          title: "The capital your content carries",
          provenance: "observed",
          note: "Each axis is one of the five capitals a piece of content can carry. Your content and the field's are measured strategy fit on the record; what the crowd shares is modeled on the pieces the crowd carried this year. Tap a series to morph the shape — the dashed outline is the field's whole content shelf.",
          axes: [
            "Scarcity",
            "Opacity",
            "Aesthetic innovation",
            "Fandom",
            "Identity signal",
          ],
          baseline: {
            id: "field",
            label: "The field's content",
            values: [12, 10, 52, 24, 34],
          },
          series: [
            { id: "yours", label: "Your content", values: [4, 4, 42, 2, 30] },
            {
              id: "carrying",
              label: "The field's carrying content",
              values: [20, 12, 68, 62, 74],
            },
            {
              id: "crowd",
              label: "What the crowd shares in UGG season",
              values: [14, 6, 40, 82, 76],
            },
          ],
        },
        {
          kind: "quadrant",
          title: "Your shelf, piece by piece",
          provenance: "observed",
          x: { label: "Capital carried", low: "quiet", high: "carried" },
          y: { label: "Crowd's pull", low: "not theirs", high: "theirs" },
          quadrants: {
            tr: "Make more of this",
            tl: "Shared, not kept",
            br: "Admired, not shared",
            bl: "Retire the format",
          },
          note: "Capital carried is each piece's graded strength on the record; the crowd's pull is modeled on who shared it. The three haloed dots are the recommended formats, placed where the field's precedents price them. Tap a dot for the read.",
          points: [
            {
              id: "argument",
              label: "Tasman vs Mini, by the crowd",
              short: "The argument",
              era: "Crowd's content",
              color: "#B388FF",
              x: 84,
              y: 86,
              w: 60,
              status: "recommended",
              note: "The October argument the feed already has — made official, with the workshop as referee and a numbered pair for the best clip.",
            },
            {
              id: "her-camera",
              label: "PinkPantheress posts the Zora first",
              short: "Her camera",
              era: "Fandom's camera",
              color: "#4FC3F7",
              x: 76,
              y: 78,
              w: 55,
              status: "recommended",
              note: "The shoe went viral on her feet before you cast her — her channel first, your film cut from her footage.",
            },
            {
              id: "bench",
              label: "The bench, weekly — the Albite whipstitch",
              short: "The bench",
              era: "The bench",
              color: "#4ADE80",
              x: 56,
              y: 58,
              w: 45,
              status: "recommended",
              note: "Thirty seconds a week from the factory floor, phone-shot — the hand is the counter-signal a feed of machine images rewards.",
            },
            {
              id: "kevin",
              label: "Kevin Abstract · In Dreams, the Tasman Flex",
              era: "Face film",
              color: "#94A3B8",
              x: 46,
              y: 66,
              w: 45,
              note: "The only piece still climbing four months on — received 60 in August — and the only one with a scene coded. A face from a subculture carries; a face from a billboard does not.",
            },
            {
              id: "sitcom",
              label: "Chavarria × UGG · the sitcom",
              era: "Face film",
              color: "#94A3B8",
              x: 62,
              y: 34,
              w: 55,
              note: "Your highest-graded piece — Trejo, Longoria, Becky G — and received at zero: a joke the trade got and the feed never saw.",
            },
            {
              id: "channel",
              label: "Channel Tres campaign",
              era: "Face film",
              color: "#94A3B8",
              x: 48,
              y: 50,
              w: 40,
              note: "Your best-received face at 65 — a scene-known name, a polished season, no afterlife.",
            },
            {
              id: "muna",
              label: "Back-to-school with MUNA",
              era: "Face film",
              color: "#94A3B8",
              x: 44,
              y: 40,
              w: 40,
              note: "A band with a real crowd, cast into a seasonal template — received at 20.",
            },
            {
              id: "wang-yibo",
              label: "Wang Yibo · global ambassador",
              era: "Fandom's camera",
              color: "#4FC3F7",
              x: 30,
              y: 72,
              w: 50,
              note: "The biggest fandom on your shelf and the thinnest piece — an announcement, received once, then silence. The crowd is his; the camera should be too.",
            },
            {
              id: "students",
              label: "Back-to-school · the art students",
              era: "Crowd's content",
              color: "#B388FF",
              x: 32,
              y: 46,
              w: 35,
              note: "The right idea — nine students, their own cameras — shipped as a trade release. Give it a room and a reason to post.",
            },
            {
              id: "orchid",
              label: "Dusty Orchid · ADÉLA, Molly Santana, Paloma Sandoval",
              era: "Face film",
              color: "#94A3B8",
              x: 36,
              y: 44,
              w: 35,
              note: "Rising names, graded on fit, received at 45 for a week.",
            },
            {
              id: "hosk",
              label: "Spring styles · Elsa Hosk & Rina Sawayama",
              era: "Face film",
              color: "#94A3B8",
              x: 34,
              y: 18,
              w: 35,
              note: "Polished and forgettable — the rationale's own words.",
            },
            {
              id: "sjp",
              label: "SJP & Stefon Diggs",
              era: "Face film",
              color: "#94A3B8",
              x: 24,
              y: 26,
              w: 35,
              note: "Two recognisable names and no documented piece — casting pull 60, everything else at the floor.",
            },
            {
              id: "metro",
              label: "Metro Boomin · filming",
              era: "Face film",
              color: "#94A3B8",
              x: 26,
              y: 30,
              w: 30,
              note: "A leak of a shoot — a set photo is not a piece.",
            },
            {
              id: "julez",
              label: "Julez J. Smith Jr.",
              era: "Face film",
              color: "#94A3B8",
              x: 22,
              y: 34,
              w: 25,
              note: "A sighting, received once at 45 and gone.",
            },
            {
              id: "olandria",
              label: "Olandria",
              era: "Face film",
              color: "#94A3B8",
              x: 16,
              y: 22,
              w: 25,
              note: "One Facebook mention — the lowest tier on every dimension.",
            },
            {
              id: "video",
              label: "'Ain't In LA' · the music-video placement",
              era: "Tie-in",
              color: "#F472B6",
              x: 8,
              y: 12,
              w: 20,
              note: "Background placement — your weakest piece of the year.",
            },
          ],
        },
        {
          kind: "plays",
          title: "Three plays, priced",
          provenance: "projected",
          plays: [
            {
              name: "Tasman vs Mini, by the crowd — the October argument made official, the workshop as referee",
              itemType: "content",
              window:
                "October · the first cold week — the styling duels invited, the vintage Classics verified on camera, the best clip gets a numbered Albite",
              strategies: [
                { code: "fandom", fit: 0.85 },
                { code: "identity_signal", fit: 0.7 },
                { code: "scarcity", fit: 0.4 },
              ],
              why: "UGG season opens on TikTok every October without you — Tasman versus Mini, the styling duels, the dupe fights — and the strongest content on the board is made by the crowd: Apple's phone campaign carries the biggest fandom fit on record, and Gap's own-denim campaign read 85. Make the argument yours: invite the comparisons, let the workshop verify the vintage pairs on camera, and give the best clip a numbered Albite. The crowd is already filming; you are only deciding whether to be in the frame.",
              effect: {
                label: "CIQ",
                delta: 0.8,
                series: [0, 0.4, 0.65, 0.75, 0.8],
              },
              precedents: 9,
              reception: "the crowd's own content is received at 80 and 85",
              similar: [
                {
                  brand: "apple",
                  brandName: "Apple",
                  title: '"Shot on iPhone" Campaign (Ongoing Activity)',
                  pts: 88.4,
                },
                {
                  brand: "gap",
                  brandName: "Gap",
                  title: 'Denim on your own" Fall 2026 Campaign',
                  pts: 42.0,
                },
                {
                  brand: "duolingo",
                  brandName: "Duolingo",
                  title: "RIP Duo Campaign",
                  pts: 41.0,
                },
              ],
            },
            {
              name: "PinkPantheress posts the Zora first — her channels, then yours, the film cut from her footage",
              itemType: "content",
              window:
                "September · the fall window she already fronts — her post the morning of, your cut a day later",
              strategies: [
                { code: "fandom", fit: 0.9 },
                { code: "identity_signal", fit: 0.6 },
                { code: "aesthetic_innovation", fit: 0.4 },
              ],
              why: "The Zora sold out on her feet last autumn before you cast her, and the field's carrying content is what the faces post themselves — RM's covers for Bottega Veneta read 77, Ningning for Gucci 68 — because a clip a face shoots reads as the face's and a film you cut about the face reads as your advertisement. Your global ambassador was received once, for an announcement. Give her the flat and the camera, let her channel go first, and cut your film from her footage rather than the other way round.",
              effect: {
                label: "CIQ",
                delta: 0.6,
                series: [0, 0.3, 0.45, 0.55, 0.6],
              },
              precedents: 8,
              reception: "the fandom's own camera is received at 80",
              similar: [
                {
                  brand: "bottega-veneta",
                  brandName: "Bottega Veneta",
                  title: "RM BTS Ambassadorship Magazine Covers",
                  pts: 77.2,
                },
                {
                  brand: "gucci",
                  brandName: "Gucci",
                  title:
                    "Beauty and the Bag campaign featuring Ningning of Aespa",
                  pts: 68.0,
                },
                {
                  brand: "dior",
                  brandName: "Dior",
                  title:
                    "Jimin Shares New Dior Campaign Content for #diorsummer27",
                  pts: 36.8,
                },
              ],
            },
            {
              name: "The bench — thirty seconds a week from the factory floor: the whipstitch, the fleece, the number on the box",
              itemType: "content",
              window:
                "September on · one clip a week — an Albite being stitched, a hide being graded, a Classic from the archive, the miniature set",
              strategies: [
                { code: "identity_signal", fit: 0.6 },
                { code: "aesthetic_innovation", fit: 0.6 },
                { code: "opacity", fit: 0.3 },
              ],
              why: "The feed is full of machine-made images, and the counter-signal it rewards is the human hand: the best-received content of the summer was Dior's hand-drawn film at 90, and Hermès' illustrated pages carried the largest content lift on the board. You hand-stitch two thousand numbered Albites, built a miniature Los Angeles for the Fluff Theater and said out loud that you would not use AI — and none of it is on your shelf. Thirty seconds a week, shot on a phone, no face: a series compounds where a film cools, and it is the only story a dupe cannot copy.",
              effect: {
                label: "CIQ",
                delta: 0.5,
                series: [0, 0.1, 0.25, 0.4, 0.5],
              },
              precedents: 8,
              reception: "the made thing is received at 90",
              similar: [
                {
                  brand: "dior",
                  brandName: "Dior",
                  title:
                    "The Story of A Miss (Miss Dior Studio Ghibli-esque Animated Video)",
                  pts: 50.1,
                },
                {
                  brand: "louis-vuitton",
                  brandName: "Louis Vuitton",
                  title:
                    "Louis Vuitton Reinvents the Trunk (130th Monogram Anniversary Trunk Campaign)",
                  pts: 44.8,
                },
                {
                  brand: "hermes",
                  brandName: "Hermès",
                  title:
                    "Hermès x Sarah Martinon Illustrated Digital Experience",
                  pts: 40.4,
                },
              ],
            },
          ],
        },
        {
          kind: "impact",
          title: "What the crowd's argument carries",
          provenance: "projected",
          delta: 0.8,
          body: "Tasman versus Mini, handed to the crowd in the first cold week of October, carries a projected lift on your published score over the following two windows — most of it in the first, as the duels and the verifications spread, with the rest arriving as the numbered pairs show up in the winners' own clips.",
        },
        {
          kind: "modelView",
          body: "Make less casting and more crowd. Your content is a face in a product shot, thirteen times over — a rapper, a model, a sitcom cast, an ambassador — graded on who is in it and shared by nobody, because it is built to be admired: a name you hired, a season you styled, a cut you approved.\n\nThe one piece still climbing is the one with a scene in it rather than a star, and the shoe that actually went viral did so on a singer's feet before you cast her. The field's content that carries is built to be passed along: a face the crowd already follows, holding the camera; a crowd allowed to make the piece; a hand shown doing the work. Every October the feed opens UGG season without you — the boot argument, the styling duels, the dupe fights — so stop casting the season and referee it: hand the crowd the argument, let PinkPantheress post the flat first, and film the bench every week. Keep the films for the holiday buyer, who wants to be reassured rather than reached — and stop reading the lane's score as proof: thirteen quiet pieces read strong and moved nobody.",
        },
      ],
    },
  ],
};
